import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TlkTextInputComponent } from '@itero/ui-toolkit-angular/text-input';
import { TlkSlideToggleComponent } from '@itero/ui-toolkit-angular/slide-toggle';
import { TlkButtonComponent } from '@itero/ui-toolkit-angular/button';
import { TlkRadioGroupDirective, TlkRadioButtonComponent } from '@itero/ui-toolkit-angular/radio-button';
import { TlkBannerComponent } from '@itero/ui-toolkit-angular/banner';
import { TlkModalWindowModule } from '@itero/ui-toolkit-angular/modal-window';
import { SearchIconComponent } from '@itero/ui-toolkit-angular/icons';
import { UnifiedPatientComponent } from './unified-patient/unified-patient.component';
import { DelayedSpinnerComponent } from './delayed-spinner/delayed-spinner.component';
import { DobInputComponent } from './dob-input/dob-input.component';
import { PatientFormsMachineService } from '../services/patient-forms-machine.service';
import { PatientFormsServicesToken } from '../services/patient-forms-services.token';
import { PatientFormsServices } from '../services/patient-forms.services';
import translations from '../assets/i18n/en.json';

@NgModule({
	declarations: [UnifiedPatientComponent],
	imports: [
		CommonModule,
		FormsModule,
		TranslateModule,
		TlkTextInputComponent,
		TlkSlideToggleComponent,
		TlkButtonComponent,
		TlkRadioGroupDirective,
		TlkRadioButtonComponent,
		DelayedSpinnerComponent,
		DobInputComponent,
		TlkBannerComponent,
		TlkModalWindowModule,
		SearchIconComponent
	],
	providers: [PatientFormsMachineService, { provide: PatientFormsServicesToken, useClass: PatientFormsServices }],
	exports: [UnifiedPatientComponent]
})
export class UnifiedPatientsModule {
	constructor(translate: TranslateService) {
		const register = (lang: string) => translate.setTranslation(lang, translations, true);

		register(translate.currentLang || translate.defaultLang || 'en');

		// The host reloads its own translation JSON (via reloadLang) on open and on
		// language change, which drops our merged keys. Re-register whenever the language
		// changes so the store keeps our pack. Projected-content labels that the translate
		// pipe fails to refresh are additionally bound to component properties in
		// UnifiedPatientComponent.
		translate.onLangChange.subscribe(({ lang }) => register(lang));
	}
}
